module.exports = __webpack_public_path__ + "img/war.c0e40c42.png";